import { Injectable } from '@angular/core';
import { Http, QueryHandlerFor, Wrapper } from '@skylab-angular-shared/core';
import { PkwiuPagedCollectionQuery, PkwiuPagedCollectionQueryHandlerBase } from '@skylab-shared/business';

@Injectable({ providedIn: 'root'})
@QueryHandlerFor(PkwiuPagedCollectionQuery)
@Wrapper(PkwiuPagedCollectionQueryHandlerBase)
export class PkwiuPagedCollectionQueryHandler {
    public constructor(
        http: Http
    ) { }
}
